import React from 'react'
import RenderInView from '@pcln/render-in-view'
import styled from 'styled-components'
import noop from 'lodash/noop'

const getMarginBottom = ({ isSponsoredAd }) =>
  /* istanbul ignore next */
  isSponsoredAd ? '0px' : '10px'

const InViewWrapper = styled.li`
  display: block;
  /* istanbul ignore next */
  margin-bottom: ${(props) => getMarginBottom(props)};
  /* istanbul ignore next */
  ${(props) => (props.isSponsoredAd ? '' : 'min-height: 60px;')}

  ${(props) => {
    if (props.isInlineAds) {
      return `@media (min-width: 840px) {
        display: none;
      }`
    }

    if (props.mobileOnly) {
      return `
        ${props.theme.flyQueries.tablet} {
          display: none;
        }
      `
    }
    return `display: block`
  }}
`

export function wrapComponentsRenderInView(listingsNodes, alwaysRenderFirstN) {
  return listingsNodes.map(
    (elem, idx) =>
      elem &&
      !elem.hide && (
        // eslint-disable-next-line react/jsx-key
        <InViewWrapper
          mobileOnly={elem.mobileOnly}
          isInlineAds={elem.inlineAds}
          isSponsoredAd={elem.isSponsoredAd}
        >
          <RenderInView
            rootMargin={'200px 0px 700px 0px'}
            alwaysRender={isNaN(alwaysRenderFirstN) ? false : idx <= alwaysRenderFirstN}
            onRender={elem.adId ? elem.renderMobileAds(elem.adId) : noop}
          >
            {elem.component}
          </RenderInView>
        </InViewWrapper>
      )
  )
}
